/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sent: NonNullable<unknown>, where: NonNullable<unknown> }} Today_Checkin_Sent_WhereInputs */

const en_us2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const pt_br2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const es_419_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const pt_pt2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const fr_fr2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const de_de2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

const it_it2_today_checkin_sent_where = /** @type {(inputs: Today_Checkin_Sent_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} ${i?.where}`)
};

/**
* | output |
* | --- |
* | "{sent} {where}" |
*
* @param {Today_Checkin_Sent_WhereInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_sent_where = /** @type {((inputs: Today_Checkin_Sent_WhereInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Sent_WhereInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_sent_where(inputs)
	if (locale === "es-419") return es_419_today_checkin_sent_where(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_sent_where(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_sent_where(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_sent_where(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_sent_where(inputs)
	return en_us2_today_checkin_sent_where(inputs)
});
export { today_checkin_sent_where as "today.checkin_sent_where" }